import Vue from "vue";

import websocket from "@/utils/websocket/index";
export const tem = {
  methods: {
     //TODO： 新增应急小组
     async addSuTem(obj) {
      let res = await this.$http.post("/tenant/emergency/group", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO： 修改应急小组
    async upSuTem(obj) {
      let res = await this.$http.put("/tenant/emergency/group", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO： 删除应急小组
    async delSuTem(id) {
      let res = await this.$http.delete(`/tenant/emergency/group/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
     //TODO：查询所有应急小组
     async getSuTemPages(params) {
      let { pageNum, pageSize, name } = params;
      let res = await this.$http.get("/tenant/emergency/group/list", {
        name: name ?? null,
        pageNum,
        pageSize,
      });
      return res;
    },
    //通过小组ID查询小组角色
    async getSuTemRole(params) {
      let { pageNum, pageSize, groupId } = params;
      let res = await this.$http.get(`/tenant/emergency/group/${groupId}`);
      return res;
    },
      //通过小组ID查询小组角色
      async getSuTemRoleID(id) {
        let res = await this.$http.get(`/tenant/emergency/group/${id}`);
        return res;
      },

    //根据ID查询详细
    async getSuTemInfo(id) {
      let res = await this.$http.get(`/tenant/emergency/group/${id}`);
      console.log(res)
      return res.data;
    },
     //TODO： 新增组角色
     async addTemToles(obj) {
      let res = await this.$http.post("/tenant/emergency/group/role", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO： 修改组角色
    async upTemToles(obj) {
      let res = await this.$http.put("/tenant/emergency/group/role", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO： 删除组角色
    async delTemToles(id) {
      let res = await this.$http.delete(`/tenant/emergency/group/role/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
  },
};
